import { Flex, Span } from "@goodfill/ui-components";
import React from "react";
import { useNavigate } from "react-router";
import { route } from "../../../../../../routes";
import { StepSubmit } from "../StepSubmit";
import { ConfirmationImage } from "./ConfirmationImage";

export const StepConfirmation: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Flex direction="col" gap={4} horizontalPadding={8} verticalPadding={8} borderBottom="thin" items="center">
      <ConfirmationImage />

      <Span size="lg" uppercase={false} font="semibold">
        Congratulations !!!
      </Span>

      <Span>Your application has been successfully submitted.</Span>

      <StepSubmit
        text="Explore bonds"
        isLoading={false}
        onClick={() => {
          navigate(route.dashboard());
        }}
      />
    </Flex>
  );
};
